import { Card, CardContent } from "./ui/card";
import { Search, Layout, Cog, Rocket, Target } from "lucide-react";

const steps = [
  {
    icon: Layout,
    title: "Map & Document",
    description:
      "We break down your business operations into clear, documented processes to establish a foundation for optimization.",
  },
  {
    icon: Target,
    title: "Unify Infrastructure",
    description:
      "Merge scattered tools and data sources into a centralized system that eliminates redundancy and improves visibility.",
  },
  {
    icon: Cog,
    title: "Deploy Workflows",
    description:
      "Implement smart automations that handle repetitive tasks, reduce errors, and free your team to focus on high-value work.",
  },
  {
    icon: Rocket,
    title: "Scale & Amplify",
    description:
      "Maximize the power of your automated systems to increase capacity, accelerate growth, and multiply output without adding headcount.",
  },
  {
    icon: Search,
    title: "Monitor & Refine",
    description:
      "Continuously track performance metrics and optimize workflows to ensure your systems evolve with your business needs.",
  },
];

export function Process() {
  return (
    <section id="process" className="bg-gray-900 py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <h2 className="mb-4 text-white">Our Process</h2>
          <p className="text-gray-400">
            A proven methodology that delivers results on time and on budget
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-5">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <Card
                key={index}
                className="relative border-gray-800 bg-gray-950"
              >
                <CardContent className="pt-6">
                  <div className="absolute -top-4 left-6 flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-r from-blue-500 to-emerald-500 text-white">
                    {index + 1}
                  </div>
                  <div className="mb-4 mt-4 flex h-12 w-12 items-center justify-center rounded-lg border border-blue-500/20 bg-gradient-to-br from-blue-500/10 to-emerald-500/10">
                    <Icon className="h-6 w-6 text-blue-400" />
                  </div>
                  <h3 className="mb-2 text-white">{step.title}</h3>
                  <p className="text-gray-400">{step.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
}
